import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blogs)/blogs/error.tsx");
